import { IDoctorProps } from '@/entities/Doctor'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IDoctorState {
  response: IResponseProps<IDoctorProps>
  current: IDoctorProps | null
  filter: string
}

export const state = (): IDoctorState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  filter: 'all'
})

export default state
